module.exports = __webpack_public_path__ + "assets/d72a44873958798d6d38aaaf3b2fff28.png";